// One lowercase, one uppercase, one digit, one special char, length 8 - 16
export const PASSWORD = /(?=^.{8,24}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_\-+}{&;:;'?/&.,<>])(?!.*\s).*$/g; // One lowercase, one uppercase, one digit, one special char, length 8 - 24
export const MOBILE = /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
